import { useState, useEffect } from 'react';
import { Content, Title, InputFormTable } from 'components';
import { Select, Input, Button, Checkbox, Radio, InputNumber } from 'antd';
import {
  useProductDeliveryDispatch,
  useProductDeliveryState,
} from '../context/ProductDeliveryProvider';
import { useGetForwardingLocations } from 'hooks/ForwardingLocationsHooks';
import { TruckOutlined } from '@ant-design/icons';
import { useUserStack } from 'store';
import SalesInformation_storeInformation from './SalesInformation_storeInformation';

import styles from '../styles';

const ProductDeliveryInformation = ({ defaultData }) => {
  const userInfo = useUserStack();
  const [forwadingLocations, setForwadingLocations] = useState([]);
  const {
    is_bundle_delivery,
    forwarding_location_id,
    is_store_pickup,
    packaging_method,
    forwarding_information,
    forwarding_date,
    receive_ids,
  } = useProductDeliveryState();

  const dispatch = useProductDeliveryDispatch();
  const { data: forwadingLocationResponse } = useGetForwardingLocations({
    shop_information_id: defaultData
      ? defaultData?.shop_information_id
      : userInfo.shop_information_id,
  });

  const handleChangeIsBundleDelivery = (e) => {
    if (e.target.checked) {
      dispatch({ type: 'CHANGE_IS_BUNDLE_DELIVERY', value: 'Y' });
    } else if (!e.target.checked) {
      dispatch({ type: 'CHANGE_IS_BUNDLE_DELIVERY', value: 'N' });
    }
  };

  const form = [
    {
      label: '묶음배송 가능 여부',
      form: [
        {
          input: (
            <>
              <Checkbox
                size="large"
                checked={is_bundle_delivery === 'Y' ? true : false}
                onChange={handleChangeIsBundleDelivery}
              >
                묶음배송 불가능 (상품별 배송비 적용)
              </Checkbox>
            </>
          ),
        },
      ],
    },
    {
      label: '출고/배송지 선택',
      form: [
        {
          input: (
            <>
              <Select
                style={{ width: 280 }}
                value={forwarding_location_id}
                onChange={(value) =>
                  dispatch({
                    type: 'CHANGE_FORWADING_LOCATION_ID',
                    value: value,
                  })
                }
                options={forwadingLocations}
              />
              {/* <Button>출고지 관리</Button> */}
            </>
          ),
        },
      ],
    },
    {
      label: '스토어 픽업 여부',
      form: [
        {
          input: (
            <>
              <Radio.Group
                value={is_store_pickup}
                onChange={(e) =>
                  dispatch({
                    type: 'CHANGE_IS_STORE_PICKUP',
                    value: e.target.value,
                  })
                }
              >
                <Radio value={'Y'}>픽업함</Radio>
                <Radio value={'N'}>픽업안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },

    // 스토어픽업장소
    ...(is_store_pickup === 'Y'
      ? [
          {
            label: `스토어픽업장소`,
            form: [
              {
                input: (
                  <SalesInformation_storeInformation
                    defaultValue={receive_ids}
                    onChange={(value) =>
                      dispatch({ type: 'receive_ids', value })
                    }
                  />
                ),
              },
            ],
          },
        ]
      : []),

    {
      label: '출고일 설정',
      required: true,
      form: [
        {
          input: (
            <>
              <InputNumber
                min={0}
                value={forwarding_date}
                onChange={(value) =>
                  dispatch({ type: 'CHANGE_FORWARDING_DATE', value: value })
                }
                style={{ width: 60 }}
              />{' '}
              일 이내 출고
            </>
          ),
        },
      ],
    },
    {
      label: '포장 방식',
      form: [
        {
          input: (
            <>
              <Radio.Group
                value={packaging_method}
                onChange={(e) =>
                  dispatch({
                    type: 'CHANGE_PACKAGING_METHOD',
                    value: e.target.value,
                  })
                }
              >
                <Radio value={'GENERAL'}>일반</Radio>
                <Radio value={'REFRIGERATION'}>냉장</Radio>
                <Radio value={'FREEZING'}>냉동</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '출고 안내사항',
      form: [
        {
          input: (
            <div style={{ width: '850px', height: '250px' }}>
              <Input.TextArea
                style={{ width: '100%', height: '100%', resize: 'none' }}
                value={forwarding_information}
                onChange={(e) =>
                  dispatch({
                    type: 'CHANGE_FORWADING_INFORMATION',
                    value: e.target.value,
                  })
                }
              />
            </div>
          ),
        },
      ],
    },
  ];

  useEffect(() => {
    if (defaultData) {
      dispatch({
        type: 'CHANGE_IS_BUNDLE_DELIVERY',
        value: defaultData.is_bundle_delivery,
      });
      dispatch({
        type: 'CHANGE_FORWADING_LOCATION_ID',
        value: defaultData.forwarding_location_id,
      });
      dispatch({
        type: 'CHANGE_IS_STORE_PICKUP',
        value: defaultData.is_store_pickup,
      });
      dispatch({
        type: 'CHANGE_FORWARDING_DATE',
        value: defaultData.forwarding_date,
      });
      dispatch({
        type: 'CHANGE_PACKAGING_METHOD',
        value: defaultData.packaging_method,
      });
      dispatch({
        type: 'CHANGE_FORWADING_INFORMATION',
        value: defaultData.forwarding_information,
      });
    }
  }, [defaultData]);

  useEffect(() => {
    if (forwadingLocationResponse && forwadingLocationResponse.status === 200) {
      const forwarding = forwadingLocationResponse.data.filter(
        (forwarding) => forwarding?.type === 'FORWARD'
      );
      setForwadingLocations(
        forwarding.map((item) => ({
          label: item.forwarding_name,
          value: item.forwarding_location_id,
        }))
      );

      if (forwadingLocationResponse.data.length > 0) {
        dispatch({
          type: 'CHANGE_FORWADING_LOCATION_ID',
          value: defaultData
            ? defaultData.forwarding_location_id
            : forwarding?.length
            ? forwarding?.[0].forwarding_location_id
            : null,
        });
      }
    }
  }, [forwadingLocationResponse]);

  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <Title size={5} align="left" style={{ marginBottom: 10 }}>
        <TruckOutlined /> 배송 정보
      </Title>
      <InputFormTable form={form} />
    </Content>
  );
};

export default ProductDeliveryInformation;
